<template>
<div v-can="'email_templates.list'">
  <div class="search-container">
    <searchbar :value="query.search" @search="search" :model="model"></searchbar>
  </div>
  <collection @itemDelete="itemDelete" :data="items" :structure="collectionData" model="email_template"></collection>
  <pagination @goToPage="goToPage" :page="page" :total-pages="total_pages"></pagination>
</div>
</template>
<script>
import Api from '@/api/EmailTemplate'
import Ui from '@/classes/Ui'
import {collectionMixin} from '@/components/mixins/Collection'
import {EventBus} from '@/EventBus.js'
import Searchbar from '@/components/layouts/partials/Searchbar'

let structure = [
  { name: 'id', credentials: 'root'},
  { name: 'name', type: 'show_with_edit_link', sortable: true},
  { name: 'language', sortable: true},
  { name: 'action', type: 'crud_action_folded' }
]

let default_sort_by = "created_at"
let default_sort_order = "DESC"
let default_filters = {}

export default {
  mixins: [collectionMixin],
  components:{
    Searchbar
  },
  data(){
    return {
      model: "email_templates",
      api: new Api(),
      collectionData: structure,
      title: "ui.pages.email-templates",
      emailNavigation: [
        { name: "external_forms",action: "external_forms.list", title: "Forms", credential: "external_forms.list" },
        { name: "email_templates", action: "email_templates.list", title: "Email templates", credential: "email_templates.list"},
      ],
      collectionMixinConfig: {
        storeResetPage: 'RESET_CURRENT_PAGE_EMAIL_TEMPLATES',
        routerName: 'email_templates',
        emptyState: 'email_templates',
        default_filters: default_filters,
        default_sort_by: default_sort_by,
        default_sort_order: default_sort_order
      }
    }
  },
  mounted(){
    if (this.page != Ui.getCurrentPageEmailTemplates()) {
      this.goToPage(Ui.getCurrentPageEmailTemplates())
    }
    this.query.sort_by = default_sort_by
    this.query.sort_order = default_sort_order

    Ui.setSecondaryHeaderTabs(this.emailNavigation)
    EventBus.$off('email_template_duplicate')
    EventBus.$on('email_template_duplicate', this.duplicate)
  },
  methods: {
    duplicate(payload){
      this.api.duplicate(payload.id).then(data=>{
        this.retrieve()
        let newForm = data.resource
        let route = { name: 'email_template_edit', params: { id: newForm.id }}
        this.$router.push(route)
      })
    }
  }
}
</script>
<style lang="scss">
.collection.email_template {
  .dot-navigation--trigger.icon{
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// EmailTemplates.vue?389ebff5